import { GeoJsonBoundries } from "interfaces/dataInterfaces"
import { geoDataApi } from "./geoDataApi"

export const geoJsonApi = geoDataApi.injectEndpoints({
  endpoints: builder => ({
    getGeoJsonBoundaries: builder.query<GeoJsonBoundries, { adm0code: number }>({
      query: ({ adm0code }) => ({
        url: `Country`,
        method: "GET",
        params: {
          countryCode: adm0code,
        },
      }),
    }),
  }),
})

export const { useLazyGetGeoJsonBoundariesQuery } = geoJsonApi
